module.exports = __webpack_public_path__ + "img/create-big.950d607.png";